import(/* webpackMode: "eager" */ "/tmp/builds/QAeAjcrUK/0/ciorg/supporter/web/sola/apps/skippy-serve/src/app/global-error.tsx");
